import React from "react";
import clsx from "clsx";
import "./log-view.styles.scss";

import { $Logger } from "../../../logger";

export interface LogViewProps {
	className?: string;
}

const BlockName = "log-view";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {},
} as const;

export type LogViewComponent = React.FC<LogViewProps> & {
	ClassNames: typeof ClassNames;
};

export const LogView = ((props: LogViewProps) => {
	React.useEffect(() => $Logger.bindWindowContext(window), []);
	return (
		<div
			id={$Logger.getUILogViewId()}
			className={clsx(LogView.ClassNames.Block, props.className)}
		/>
	);
}) as LogViewComponent;
LogView.ClassNames = ClassNames;
